import React, { Component, Fragment } from 'react';
import { Layout, Table, Popover, Row, Icon, Input, Button, Tooltip } from 'antd';
import { Flex } from 'reflexbox';

import { api } from '../../services';

import { observer, inject } from 'mobx-react';
import moment from 'moment';

import { cloneDeep } from 'lodash';

import './Clients.css';

const savePdf = (function() {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  return function(data, fileName) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

const contactsPopoverContent = user => (
  <Layout className="clientsPopoverContent">
    <Row>
      <Icon type="mobile" /> {user.mobile}
    </Row>
    <Row>
      <Icon type="environment-o" /> {user.address}, {user.number} - {user.postcode} {user.city}
    </Row>
    <Row>
      <Icon type="mail" /> {user.email}
    </Row>
  </Layout>
);

const carPopoverContent = user => {
  const { car } = user.assets[0];

  return (
    <Layout className="carPopoverContent">
      {car && (
        <Row>
          <Row className="model">
            <span>{car.make.descrizione || car.make} </span>
            <span>{car.model.descrizione || car.model}</span>
            {car.matriculationYear && (
              <span>
                &nbsp;(
                {car.matriculationYear})
              </span>
            )}
          </Row>
          <Row>{car.type && (car.type.descrizione || car.type)}</Row>
          <Row>VIN: {car.casenumber}</Row>
        </Row>
      )}
    </Layout>
  );
};

const defaultSearchState = {
  client: { filterDropdownVisible: false, filtered: false, values: { name: '', email: '' } },
  car: { filterDropdownVisible: false, filtered: false, values: { plate: '', vin: '' } }
};

@inject('usersStore', 'translationsStore', 'registrationStore')
@observer
export default class Clients extends Component {
  constructor(props) {
    super(props);
    this.defaultDataSourceQuery = '';
    this.state = {
      search: {
        client: { filterDropdownVisible: false, filtered: false, values: { name: '', email: '' } },
        car: { filterDropdownVisible: false, filtered: false, values: { plate: '', vin: '' } }
      },
      loading: false,
      dataSource: [],
      dataSourceIsFiltered: false,
      dataSourceQuery: this.defaultDataSourceQuery,
      dataSourceFiltered: [],
      dataSourceFilteredMore: []
    };
  }

  componentDidMount() {
    const { usersStore } = this.props;
    this.setState({ loading: true });
    usersStore.load().then(() => {
      let clients = usersStore.clients.map((c, i) => Object.assign({}, c, { key: `client_${i}` }));
      this.clients = clients;
      this.setState({ loading: false, dataSource: clients, dataSourceFiltered: clients }, () => {
        this.setState({ dataSourceFilteredMore: clients });
      });
    });
  }

  filter(e) {
    e && e.preventDefault();
    let clientFiltered = false;
    let carFiltered = false;

    const { name: searchedName, email: searchedEmail } = this.state.search.client.values;
    const { plate: searchedPlate, vin: searchedVin } = this.state.search.car.values;

    let dataSource = this.clients;
    this.setState(
      {
        dataSourceFilteredMore: dataSource
          .filter(d => {
            if (searchedName && searchedName.length > 2) {
              clientFiltered = true;
              return (d.firstname + d.lastname).toLowerCase().indexOf(searchedName.toLowerCase()) > -1;
            }
            return true;
          })
          .filter(d => {
            if (searchedEmail && searchedEmail.length > 2) {
              clientFiltered = true;
              return (d.email + d.username).toLowerCase().indexOf(searchedEmail.toLowerCase()) > -1;
            }
            return true;
          })
          .filter(d => {
            if (searchedPlate && searchedPlate.length > 1) {
              carFiltered = true;
              return d.assets[0].car.plate.toLowerCase().indexOf(searchedPlate.toLowerCase()) > -1;
            }
            return true;
          })
          .filter(d => {
            if (searchedVin && searchedVin.length > 2) {
              carFiltered = true;
              return d.assets[0].car.casenumber.toLowerCase().indexOf(searchedVin.toLowerCase()) > -1;
            }
            return true;
          })
      },
      () => {
        const newSearchState = cloneDeep(this.state.search);
        newSearchState.client.filtered = clientFiltered;
        newSearchState.car.filtered = carFiltered;
        newSearchState.client.filterDropdownVisible = false;
        newSearchState.car.filterDropdownVisible = false;
        this.setState({ search: newSearchState });
      }
    );
  }

  reset(type) {
    return e => {
      e.preventDefault();
      const newSearchState = cloneDeep(this.state.search);
      newSearchState[type] = cloneDeep(defaultSearchState[type]);
      this.setState({ search: newSearchState }, () => {
        this.filter();
      });
    };
  }

  onInputChange(e) {
    const currentSearchState = cloneDeep(this.state.search);
    const [column, field] = e.target.name.split('.');
    currentSearchState[column].values[field] = e.target.value;
    this.setState({ search: currentSearchState });
  }

  onQueryChange = e => {
    const { value } = e.target;
    this.handleQueryUpdate(value);
  };

  handleQueryUpdate = newValue => {
    if (newValue === this.defaultDataSourceQuery) {
      this.handleQueryReset();
      return;
    }
    let { dataSource: dataSourceFiltered } = this.state;
    dataSourceFiltered = dataSourceFiltered.filter(user => {
      const {
        assets: [
          {
            imei,
            car: { plate }
          }
        ],
        ragsoc = '',
        firstname = '',
        lastname = ''
      } = user;
      const name = `${firstname} ${lastname}`.trim();
      return (
        name.toLowerCase().includes(newValue.toLowerCase()) ||
        ragsoc.toLowerCase().includes(newValue.toLowerCase()) ||
        plate.toLowerCase().includes(newValue.toLowerCase()) ||
        imei.toLowerCase().includes(newValue.toLowerCase())
      );
    });
    this.setState({ dataSourceIsFiltered: newValue !== this.defaultDataSourceQuery, dataSourceQuery: newValue, dataSourceFiltered }, () => {
      this.setState({ dataSourceFilteredMore: dataSourceFiltered, search: defaultSearchState });
    });
  };

  handleQueryReset = () => {
    const { dataSource: dataSourceFiltered } = this.state;
    this.setState({ dataSourceIsFiltered: false, dataSourceQuery: this.defaultDataSourceQuery, dataSourceFiltered }, () => {
      this.setState({ dataSourceFilteredMore: dataSourceFiltered, search: defaultSearchState });
    });
  };

  render() {
    const columns = [
      {
        title: 'Product',
        key: 'date',
        render: (text, record) => (
          <div>
            <div>{record.assets[0].subscription.description}</div>
            <span>
              <Tooltip title="Signature date">
                <Icon type="form" />
                &nbsp;
                {moment(record.assets[0].subscription.signatureDate).format('L')}
              </Tooltip>
            </span>
            &nbsp;
            <span>
              <Tooltip title="Decurring date">
                <Icon type="clock-circle-o" />
                &nbsp;
                {moment(record.assets[0].subscription.decurringDate).format('L')}
              </Tooltip>
            </span>
          </div>
        )
      },
      {
        title: 'Client',
        key: 'client',
        render: (text, record) => (
          <div className="client">
            <Popover placement="right" content={contactsPopoverContent(record)}>
              <span>
                <span>
                  <span>{record.firstname}</span> <span>{record.lastname}</span>
                </span>
                <Icon type="idcard" />
              </span>
            </Popover>
          </div>
        ),
        onFilterDropdownVisibleChange: visible => {
          const newSearchState = cloneDeep(this.state.search);
          newSearchState.client.filterDropdownVisible = visible;
          this.setState(
            {
              search: newSearchState
            },
            () => this.searchInputName && this.searchInputName.focus()
          );
        },
        filterDropdownVisible: this.state.search.client.filterDropdownVisible,
        filteredValue: this.state.search.client.filtered ? [''] : null,
        filterDropdown: (
          <Row>
            <Row className="custom-filter-dropdown">
              <Input
                ref={ele => (this.searchInputName = ele)}
                placeholder="Filter by name"
                name="client.name"
                value={this.state.search.client.values.name}
                onChange={this.onInputChange.bind(this)}
                onPressEnter={this.filter.bind(this)}
              />
            </Row>
            <Row className="custom-filter-dropdown">
              <Input
                ref={ele => (this.searchInputEmail = ele)}
                placeholder="Filter by email"
                name="client.email"
                value={this.state.search.client.values.email}
                onChange={this.onInputChange.bind(this)}
                onPressEnter={this.filter.bind(this)}
              />
            </Row>
            <Row className="ant-table-filter-dropdown-btns">
              <a onClick={this.filter.bind(this)}>OK</a>
              <a onClick={this.reset('client').bind(this)}>Reset</a>
            </Row>
          </Row>
        )
      },
      {
        title: 'Car',
        key: 'car',
        render: (text, record) => (
          <div className="car">
            <Popover placement="left" content={carPopoverContent(record)}>
              <span>
                <span>
                  <span className="plate">{record.assets[0].car.plate}</span>
                </span>
                <Icon type="profile" />
              </span>
            </Popover>
          </div>
        ),
        onFilterDropdownVisibleChange: visible => {
          const newSearchState = cloneDeep(this.state.search);
          newSearchState.car.filterDropdownVisible = visible;
          this.setState(
            {
              search: newSearchState
            },
            () => this.searchInputPlate && this.searchInputPlate.focus()
          );
        },
        filterDropdownVisible: this.state.search.car.filterDropdownVisible,
        filteredValue: this.state.search.car.filtered ? [''] : null,
        filterDropdown: (
          <Row>
            <Row className="custom-filter-dropdown">
              <Input
                ref={ele => (this.searchInputPlate = ele)}
                placeholder="Filter by plate"
                name="car.plate"
                value={this.state.search.car.values.plate}
                onChange={this.onInputChange.bind(this)}
                onPressEnter={this.filter.bind(this)}
              />
            </Row>
            <Row className="custom-filter-dropdown">
              <Input
                ref={ele => (this.searchInputVin = ele)}
                placeholder="Filter by vin"
                name="car.vin"
                value={this.state.search.car.values.vin}
                onChange={this.onInputChange.bind(this)}
                onPressEnter={this.filter.bind(this)}
              />
            </Row>
            <Row className="ant-table-filter-dropdown-btns">
              <a onClick={this.filter.bind(this)}>OK</a>
              <a onClick={this.reset('car').bind(this)}>Reset</a>
            </Row>
          </Row>
        )
      },
      {
        title: 'Device',
        key: 'device',
        render: (text, record) => <span>{record.assets[0].imei}</span>
      },
      {
        title: 'Contract',
        key: 'contract',
        className: 'contract',
        render: (text, record) => {
          return (
            !!record.assets[0].subscription.signedDocumentName && (
              <a
                onClick={() => {
                  api({ action: 'download contract' }, record._id).then(result => {
                    return savePdf(result, `${record.assets[0].subscription.signedDocumentName}`);
                  });
                }}
              >
                <i className="anticon anticon-file" />
              </a>
            )
          );
        }
      }
    ];

    const { translationsStore } = this.props;
    const { current: t } = translationsStore;
    const { dataSourceIsFiltered, dataSourceQuery, dataSourceFiltered, dataSourceFilteredMore } = this.state;

    return (
      <Flex column align={'stretch'} pl={30} pr={30} className="Registrations">
        <Flex column>
          <Layout className="Clients">
            <Layout.Header>Clients list</Layout.Header>
          </Layout>
        </Flex>
        <Flex justify={'center'} align={'center'}>
          <Popover content={t['shared']['lblFilterQueryLongHint']} placement="bottom">
            <Input
              className="lblFilterQuery"
              type="text"
              placeholder={t['shared']['lblFilterQueryHint']}
              value={dataSourceQuery}
              onChange={this.onQueryChange}
              suffix={dataSourceIsFiltered ? <Icon type="close-circle" style={{ cursor: 'pointer', color: 'rgba(0,0,0,.45)' }} onClick={this.handleQueryReset} /> : <Fragment />}
            />
          </Popover>
        </Flex>
        <Flex column>
          <Layout className="Clients">
            <Layout.Content>
              <Table loading={this.state.loading} dataSource={this.state.dataSourceFilteredMore} columns={columns} />
            </Layout.Content>
          </Layout>
        </Flex>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients/Clients.js